import { TypographyHeading } from "shared/molecules/typography-layout";
import { Box, InputLabel, Paper, FormControl, Select, MenuItem, Pagination, Button} from "@mui/material";
import Loader from "pages/build-test/loader";
import SectionTable from "shared/organisms/tables/table";
import { useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import NoDataFound from "shared/molecules/no-data";
import { Stack } from "@mui/material"
import { table } from "./helper"
import liveClassClientService from "utils/graphql/liveclassClient";
import {GET_SESSION_USAGES } from "utils/graphql/services/live-classes/queries";
import { useLocation } from "react-router-dom";
import { utcToIst } from "utils/time-util/utcIstTime";
import CollapsibleTable from "shared/organisms/tables/collapsible-table";
import { SessionUsagesFilter } from "./filter";

export default function SessionUsages() {

    const location: any = useLocation();
    const liveSessionId = location?.state?.row?.liveSessionId || null;
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);

    const [searchPayload, setSearchPayload] = useState({});
    const [getSessionUsagesList, { loading, error, data }] = useLazyQuery(
        GET_SESSION_USAGES,
        {
            client: liveClassClientService,
        },
    );

    useEffect(() => {
        getSessionUsagesList({
            variables: {
                input: {
                    limit: limit,
                    offset: (page - 1) * limit,
                    liveSessionId: liveSessionId,
                    ...searchPayload,
                },
            },
        });
    }, [page, limit, searchPayload, liveSessionId]);

    const sessionUsagesData= data?.getSessionUsages?.sessionUsages?.map((item: any) => ({
        ...item,
        joinedAt: utcToIst(item.joinedAt),
        leftAt: utcToIst(item.leftAt),
        createdAt: utcToIst(item.createdAt),
        updatedAt: utcToIst(item.updatedAt),
    })) || [];

    return (
        <>

            <TypographyHeading sx={{ mb: 2, mt: 3, fontSize: "25px" }}>
                Liveclass Session Usages{" "}
            </TypographyHeading>

             <SessionUsagesFilter
                setSearchPayload={setSearchPayload}
                setPage={setPage}
            />

            <Paper elevation={2} sx={{ p: 2, mt: 3 }}>

                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                    <FormControl size="small" sx={{ width: 140 }}>
                        <InputLabel>Show Entries</InputLabel>
                        <Select
                            value={limit}
                            label="Show Entries"
                            onChange={(e) => {
                                setLimit(Number(e.target.value));
                                setPage(1); // reset to first page
                            }}
                        >
                            <MenuItem value={5}>5</MenuItem>
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                            <MenuItem value={500}>500</MenuItem>
                        </Select>
                    </FormControl>
                </Box>

                <div>
                    {loading && <Loader />}
                    {!loading && data?.getSessionUsages?.sessionUsages?.length > 0 ? (
                        <CollapsibleTable
                            data={sessionUsagesData || []}
                            table={table}
                            id="id"
                            name="id"
                            rowsPerPageCount={limit}
                            style="false"
                            totalRecords={data?.getSessionUsages?.totalCount || 0}
                            paginationSegmentApi="false"
                            viewSecondaryData="true"
                            showPaginationFooter={false}
                        />
                    ) : (
                        <div>{!loading && <NoDataFound message="No Data Found" />}</div>
                    )}
                </div>

                <Box sx={{ marginTop: "20px" }}>
                    <Stack
                        direction="row"
                        spacing={2}
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Pagination
                            count={Math.ceil(data?.getSessionUsages?.totalCount / limit) || 1}
                            page={page}
                            onChange={(e, value) => setPage(value)}
                            color="primary"
                            size="medium"
                        />
                    </Stack>
                </Box>

            </Paper>
        </>
    )
}
